import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//
// Library Service Modules
//
import { RtiHttpServiceModule } from '../../../lib/angular/service/rti-HttpService.module';
import { RtiHttpService } from '../../../lib/angular/service/rti-HttpService';
import { RtiJsonService } from '../../../lib/angular/service/common/rti-JsonService';
import { RtiMessageBusService } from '../../../lib/angular/service/common/rti-MessageBusService';
//
// Applicaiton Specific Shared Services(s)
//
import { DDFeatureConfigService } from './common/dd-feature-config.service';

const SERVICES = [
    DDFeatureConfigService,
    RtiHttpService,
    RtiJsonService,
    RtiMessageBusService
];

@NgModule({ imports: [RtiHttpServiceModule], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class DDFeatureConfigServiceModule {
    public static forRoot(): ModuleWithProviders<DDFeatureConfigServiceModule> {
        return {
            ngModule: DDFeatureConfigServiceModule,
            providers: SERVICES
        };
    }
}
